export const LoginPageState = Object.freeze({
    FORM_LOGIN: 'login-page',
    FORGOT_PASSWORD_SUCCESS: 'forgot-password-success',
    FORGOT_PASSWORD_LOADING: 'forgot-password-loading'
})
